import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  ref: "grid-top",
  class: "scroll-mt-10"
}
const _hoisted_3 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5" }

import { useTemplateRef } from 'vue';
import { useImagesStore } from "../stores/images";
import LoadingIndicator from "@js/components/LoadingIndicator.vue";
import ListPagination from "@js/components/ListPagination.vue";
import ImageItem from "./ImageItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageList',
  setup(__props) {

const gridTop = useTemplateRef('grid-top')
const store = useImagesStore();

function onPageChange(page: number) {
  store.currentPage = page;
  if (gridTop.value) {
    gridTop.value.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
}

store.getImages();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    (_unref(store).images && _unref(store).images.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).images, (image) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image.id
              }, [
                _createVNode(ImageItem, { image: image }, null, 8, ["image"])
              ]))
            }), 128))
          ]),
          _createVNode(ListPagination, {
            "total-pages": _unref(store).totalPages,
            "current-page": _unref(store).currentPage,
            onChange: onPageChange
          }, null, 8, ["total-pages", "current-page"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(LoadingIndicator, {
      "is-loading": _unref(store).isLoading
    }, null, 8, ["is-loading"])
  ]))
}
}

})